module.exports = __webpack_public_path__ + "img/gh-43160.asm.0695abab.jpg";